// extracted by mini-css-extract-plugin
export var legendIndicator = "_a5-1";
export var legendRight = "_a5-0";